import { Component, OnInit } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { EcitationReportService } from 'src/services/ecitation-report.service';

@Component({
    selector: 'app-ecitation-dayofweek-usage-report',
    templateUrl: './ecitation-dayofweek-usage-report.component.html',
    styleUrls: ['./ecitation-dayofweek-usage-report.component.css'],
    standalone: false
})
export class EcitationDayofweekUsageReportComponent implements OnInit {
  title = 'ng2-charts-demo';

  public barChartLegend = false;

  public barChartData: ChartConfiguration<'bar'>['data'] | undefined;
  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
  };
 
  constructor(private ecitationReportService: EcitationReportService) { }
  ngOnInit(): void {
    let lables:any =[];
    let data:any =[]
    this.ecitationReportService.getDayOfWeekReport().subscribe((res:any) => {
      
      res.forEach((x: { dayOfWeek: any; citationCount: any; }) => {
        lables.push(x.dayOfWeek)
        data.push(x.citationCount)
        this.barChartData=
        {
          labels: lables,
          datasets: [
            { data: data}
          ]
        };
      
      });
    });
  }
 

}
